import { useState, useEffect } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on mount
    checkIfMobile();

    // Listen for window resize
    window.addEventListener('resize', checkIfMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return isMobile;
};

// Mobile styling utilities
export const getMobileTextSize = (isMobile, baseSize) => {
  if (!isMobile) return baseSize;
  
  // Increase text size for mobile readability
  const sizeMap = {
    12: 14,
    14: 16,
    16: 18,
    18: 20,
    20: 22,
    24: 26,
    28: 30,
    32: 34,
  };
  
  return sizeMap[baseSize] || baseSize + 2;
};

export const getMobileTouchTarget = (isMobile, baseHeight = 40) => {
  return isMobile ? Math.max(44, baseHeight) : baseHeight;
};

export const getMobilePadding = (isMobile, basePadding = 16) => {
  return isMobile ? basePadding + 4 : basePadding;
};

export const getMobileMargin = (isMobile, baseMargin = 16) => {
  return isMobile ? baseMargin + 4 : baseMargin;
};

export default useIsMobile; 